import React from 'react';
import styled from '@emotion/styled';
import { ArrowLink } from '../../../../../ui';
import { Section } from '../Section';
import { getLinkPropsForUrl } from '../../../../shared/components/link/utils/getLinkPropsForUrl';
import themed from '../../../../../ui/themer/themed';

export const StyledErrorSection = styled(Section)`
	border-left: 5px solid ${themed(({ color }) => color.state.error)};
	background: rgba(206, 17, 38, 0.05);
	padding-left: 30px;
	padding-bottom: 40px;
`;

export interface IErrorSectionProps {
	contentType: string;
	entryId: string;
}

export const ErrorSection = ({ entryId, contentType }: IErrorSectionProps) => (
	<StyledErrorSection>
		<h2>{getTitle(contentType)}</h2>
		<p>
			Please verify you have completed all required fields.
			<br />
			<small>This message will only appear in preview mode.</small>
		</p>
		<ArrowLink {...getEditorLinkProps(entryId)}>Open editor</ArrowLink>
	</StyledErrorSection>
);

function getTitle(contentType: string) {
	const description = contentType.replace(/-/g, ' ');
	return `This ${description} could not be rendered.`;
}

function getEditorLinkProps(entryId: string) {
	const space = process.env.CONTENTFUL_SPACE;
	const environment = process.env.CONTENTFUL_ENVIRONMENT;

	const url = `https://app.contentful.com/spaces/${space}/environments/${environment}/entries/${entryId}`;

	return getLinkPropsForUrl(url);
}
